<template>
	<div class="personal">
		<el-form :inline="true" :model="formInline" class="demo-form-inline">
		  <!--<el-form-item label="姓名：">
		    <el-input v-model="formInline.memberName" placeholder="请输入姓名"></el-input>
		  </el-form-item>
		  <el-form-item label="出生年：">
		    <el-select  v-model="formInline.bithStartDate" placeholder="出生日期开始" clearable>
		      <el-option
		      	v-for="item in option"
		      	:key="item.value"
		        :label="item.label"
		        :value="item.value">
		      </el-option>
		    </el-select>
		    <span>到</span>
		    <el-select v-model="formInline.bithEndDate" placeholder="出生日期结束" clearable>
		      <el-option
		      	v-for="item in optionend"
		      	:key="item.value"
		        :label="item.label"
		        :value="item.value"></el-option>
		    </el-select>
		  </el-form-item>-->
		  <el-form-item>
		  	   <span>性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别：</span>
		  	  <el-radio-group v-model="formInline.planSex">
			    <el-radio label="">全部</el-radio>
			    <el-radio :label="0">男</el-radio>
			    <el-radio :label="1">女</el-radio>
			  </el-radio-group>
		  </el-form-item>
		  <el-form-item style="padding:0 100px;" label="剑种：">
		  	  <el-radio-group v-model="formInline.planWeapon">
		  	  	<el-radio label="">全部</el-radio>
			    <el-radio :label="1">花剑</el-radio>
			    <el-radio :label="2">重剑</el-radio>
			    <el-radio :label="3">佩剑</el-radio>
			  </el-radio-group>
		  </el-form-item>
		  <br>
		  <el-form-item>
		  	<span>组&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别：</span>
		  	  <el-radio-group v-model="formInline.planCode">
		  	  	<el-radio >全部</el-radio>
			    <el-radio  v-for="item in plan"
			    			   :key="item.planName"
			    			  :label="item.planCode">
			    			  	{{item.planName}}
			    </el-radio>
			  </el-radio-group>
		  </el-form-item>
		  <br>
		  <el-form-item >
		  	  <span>缴费状态：</span>
		  	  <el-radio-group v-model="formInline.payStatus">
			    <el-radio label="">全部</el-radio>
			    <el-radio :label="0">未缴费</el-radio>
			    <el-radio :label="1">已缴费</el-radio>
            <el-radio :label="2">线下缴费</el-radio>
			  </el-radio-group>
		  </el-form-item>
		  <el-form-item>
		    <el-button type="primary" @click="onSubmit"  class="bb" round>查询</el-button>
		  </el-form-item>
		</el-form>
		<div class="table clear">
			<el-button type="primary" @click="add"  class="bb" round v-if="matchInfo.matchStatus==1">增加报名</el-button>
			<el-button type="primary" @click="onlinePayment"  class="bb" round  v-if="nowDate<(matchInfo.signEndTime+24*60*60*1000)">线上缴费</el-button>
			<a type="primary"
				:href="'/marlin/sign/data/sign/union/export?matchCode='+code"
				class="el-button el-button--primary bb"
				v-if="tableData3.length!=''"  round style="border-radius:20px">导出EXCEL</a>
				<span style="float: right;line-height: 50px;">共{{person}}个团体</span>
		</div>
		<div class="elTable">
			<el-table
		    ref="multipleTable"
		    :data="tableData3"
		    tooltip-effect="dark"
		    style="width: 100%"
		    border
		    @cell-mouse-enter="cellMouseEnter"
			@cell-mouse-leave="cellMouseLeave"
		    @selection-change="handleSelectionChange">
		    <el-table-column
		     	 type="selection"
		      	 width="55"
		      	 :selectable="selectable"
		      	 align="center">
		    </el-table-column>
			<el-table-column prop="teamName" label="统计" width="240" align="center"
				>
				<template slot-scope="scope">
					<p v-if="(scope.row.ortherSignTeamCount)>0"
			          @click="lookInfo(scope.$index, scope.row)"
			          style="color: #44c1de;cursor: pointer;">
						<span>【其他俱乐部有{{scope.row.ortherSignTeamCount}}个团体{{scope.row.ortherSignMemberCount}}人报名】</span>
					</p>
					<p v-else>
						【暂时没俱乐部团体报名】
					</p>
					</template>
			</el-table-column>
		    <el-table-column label="团队成员"align="center">
		      	<template slot-scope="scope">
		      			<p>
		      			  	<a v-for="(item,index) in scope.row.memberList" style="color:#44c1de" @click="handleLook(scope.$index, scope.row)">
				        			{{item.memberName}} {{index+1==scope.row.memberList.length?'':','}}
				        		 </a>
				        		 <el-button type="primary"
				        		 	 @click="addPerson(scope.row)"
				        		 	  v-if="(null==(scope.row.memberList) || (scope.row.memberList.length) < 2) && scope.row.payStatus == 0"
				        		 	 style="margin-left: 15px;"
				        		 	 size="mini"
				        		 	 round
				        		 	 class="bb">添加</el-button>
		      			 </p>
			     </template>
		    </el-table-column>
			<el-table-column
				  align="center"
			      prop="itemName"
			      label="已报小项"
			      width="180">
			</el-table-column>
			<el-table-column
				  align="center"
			      prop="signPrice"
			      label="金额（人民币）"
			      width="120">
			</el-table-column>
			<el-table-column
			      label="缴费状态"
			      width="100"
			      align="center">
			      <template slot-scope="scope">
			        <span style="margin-left: 10px">{{scope.row.payStatus | payToData}}</span>
			     </template>
			</el-table-column>
		    <el-table-column label="操作"
			    	fixed="right"
			    	width="80"
			    	align="center">
			    	<template slot-scope="scope" v-if="(scope.row.payStatus)==0">
			        <el-button
				          size="mini"
				          type="danger"
				          icon="el-icon-delete"
				          @click="handleDelete(scope.$index, scope.row)"
				          v-if="scope.row.id==0"
				          ></el-button>
				        <el-button
				          size="mini"
				          type="info"
				          icon="el-icon-delete"
				          @click="handleDelete(scope.$index, scope.row)"
				          v-else
				          ></el-button>
			      </template>
			 </el-table-column>

		  </el-table>
		</div>
				<!--增加报名-->
		<el-dialog title="报名" :visible.sync="dialogFormVisible" width="400px">
		  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
			  <el-form-item label="小项：" prop="planCode">
			     <el-select v-model="ruleForm.planCode" placeholder="请选择" @change="selectToSex">
				    <el-option
				      v-for="item in planItemList"
				      :key="item.itemCode"
				      :label="item.itemName"
				      :value="item.itemCode">
				    </el-option>
				  </el-select>
			  </el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
			    <el-button type="primary" @click="submitForm('ruleForm')"  class="bb" round>添加</el-button>
			    <el-button @click="dialogFormVisible = false" round>取消</el-button>
			</div>
		</el-dialog>
		<!--修改-->
		<!--成员列表-->
		<el-dialog title="成员列表" :visible.sync="personShow" >
		  <el-table :data="personList"
		  	@cell-mouse-enter="cellMouseEnter"
			@cell-mouse-leave="cellMouseLeave"
			border>
		    <el-table-column property="memberName" label="姓名"></el-table-column>
		    <el-table-column label="性别" width="80">
		    		<template slot-scope="scope">
		    			<span>{{scope.row.memberSex | sexToData}}</span>
		    		</template>
		    </el-table-column>
		    <el-table-column label="出生日期" width='140'>
		    		<template slot-scope="scope">
		    			<span>{{scope.row.memberBith | timestampToDate}}</span>
		    		</template>
		    </el-table-column>
		     <el-table-column label="剑种" width="105">
		     	<template slot-scope="scope">
		    			<span>{{scope.row.memberWeapon | WeaponToData}}</span>
		    		</template>
		     </el-table-column>
		    <el-table-column property="address" label="操作" width="100">
		    		<template slot-scope="scope" v-if="(delStatus)==0">
		    			<el-button
			          size="mini"
			          type="danger"
			          v-if="scope.row.id==0"
			          icon="el-icon-delete"
			          @click="personDelete(scope.$index, scope.row)"></el-button>
			          <el-button
			          size="mini"
			          type="info"
			          v-else
			          icon="el-icon-delete"
			          @click="personDelete(scope.$index, scope.row)"></el-button>
			     </template>
		    </el-table-column>
		  </el-table>
		  <div slot="footer" class="dialog-footer">

		    <el-button @click="personShow = false"  round>取 消</el-button>
		    <el-button type="primary" @click="personShow = false"  class="bb" round>确 定</el-button>
		    <el-button type="primary" @click="addPerson(row)"
		    v-if="(null==tableData3.memberList || (tableData3.memberList.length) < 4) && tableData3.payStatus == 0">添加新成员</el-button>
		    	<span v-else></span>
		  </div>
		</el-dialog>

		<!--新增成员模态框-->
		<el-dialog title="新增成员" :visible.sync="addPersonShow" width="400px">
      <div class="sign-remark">
        注：总共人数为符合当前项目运动员数，不可选的人数需要完善监护人信息，请至俱乐部中运动员管理中完善运动员监护人信息。
      </div>
		  <el-form :model="addPersonForm">
		    <el-form-item label="姓名：" prop="memberCode">
			     <el-select v-model="addPersonForm.memberCode" placeholder="请选择">
				    <el-option
				      v-for="item in newOption"
				      :key="item.memberCode"
				      :label="item.memberName"
				      :value="item.memberCode"
              :disabled="item.disabled"
            >
				    </el-option>
				  </el-select>
			  	</el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="addPersonShow = false" round>取 消</el-button>
		    <el-button type="primary" @click="addPersonSubmimt" class="bb" round>确 定</el-button>
		  </div>
		</el-dialog>

	    <!--缴费成功后 查看信息-->
	    <el-dialog title="查看信息" :visible.sync="lookVisible">
		  <el-table :data="lookData">
		    <el-table-column property="clubShortName" label="俱乐部" width="105"></el-table-column>
		    <el-table-column property="clubContactName" label="联系人" width="105"></el-table-column>
		    <el-table-column property="clubContactTel" label="电话"></el-table-column>
		    <el-table-column property="clubContactEmail" label="俱乐部邮箱"></el-table-column>
		    <el-table-column property="memberCount" label="报名成员数量" width="105"></el-table-column>
		  </el-table>
		</el-dialog>
    <div style="display: none">{{changeMatchMsg}}</div>

  </div>
</template>

<script>
	import axios from 'axios'
	export default{
		data(){
			return{
				 userInfos:JSON.parse(localStorage.getItem("userInfos")),
				 matchInfo:JSON.parse(sessionStorage.getItem('matchInfo')),
				 person:0,
				 plan:{},
				 plan1:{},//添加
				 plan2:{},//编辑
				 formInline: {
				 	"memberCode":"",
					"clubCode":"",//俱乐部编码 必填
					"matchCode":"",//比赛编码 必填
					"planSex":"",//性别 选填
					"planWeapon":"",//剑种 选填
					"planCompetition":2,//赛式 选填
					"payStatus":'',//支付状态 选填,
           "pageSize":10000
	      		},
	      		option:[],
	        		optionend:[],
	        		options:[],//add获取姓名
	        		newOption:[],
	        		rowOption:[],
	        		planItemList:[],
				tableData3:[],
				tablePerson:[],

				dialogFormVisible:false,
				editFormVisible:false,
			    rules: {
		          teamName: [
		            { required: true, message: '请选择人员', trigger: 'blur' },
		          ],
		          planCode: [
		            { required: true, message: '请选择性别', trigger: 'change' }
		          ],
		          planSex: [
		            { required: true, message: '请选择运动员性别', trigger: 'change' }
		          ],
		          planWeapon: [
		            { required: true, message: '请选择剑种', trigger: 'change' }
		          ]
		       },
		       ruleForm:{
		            "planCode":"",
                "planSex":'',//成员性别 0-男 1-女  必填
                "planWeapon":null,//剑种 1-花剑 2-重剑 3-配剑 必填
                "planCompetition":2
		        },
		        href:'',
		        editForm:{},

		        personList:[],
		        personShow:false,
		        addPersonShow:false,
		        addPersonForm:{},
		        sCode:'',

		        lookData:[],
		        lookVisible:false,

		        	//缴费
		        multipleSelection:[],
		        signCodeList:[],
		        delStatus:null,
            nowDate:null,
            matchCode:'',
            code:this.$route.query.matchCode

        }
			},
    computed: {
      changeMatchMsg(){
        if(this.$store.state.matchCodeMsg=="" || null==this.$store.state.matchCodeMsg){
          this.$store.commit("matchCodeChange",this.$route.query.matchCode)
        }else{
          this.matchCode = this.$store.state.matchCodeMsg;
        }
        this.onSubmit();
        this.matchInfoList()
        return this.$store.state.matchCodeMsg
      }
    },
    filters: {
        timestampToDate(data) {
          return global.timestampToDate(data);
        },
        WeaponToData(val){
            if(val==1){
              return val='花剑'
            }else if(val==2){
              return val='重剑'
            }else if(val==3){
              return val='配剑'
            }
        },
        sexToData(val){
            return val==0 ? '男':'女'
        },
        payToData(val){
          let result = ''
          if(val == 0){
            result = '未缴费'
          }else if(val == 1){
            result = '已缴费'
          }else if(val == 2){
            result = '线下缴费'
          }
          return result
        },
		},
		mounted(){
				var self=this
		     //年份
		    	for(var i=0;i<70;i++){
				var l=(2018-i)
				var v=(2018-i)+'-01-01'
				var o={value:v,label:l}
				this.option.push(o)

				var vend=(2018-i)+'-12-31'
				var oend={value:vend,label:l}
				this.optionend.push(oend)
		    	}
      if(this.$store.state.matchCodeMsg=="" || null==this.$store.state.matchCodeMsg){
        this.$store.commit("matchCodeChange",this.$route.query.matchCode)
      }else{
        this.matchCode = this.$route.query.matchCode
      }
			//路由传过来的参数
		    //this.matchInfo=this.$route.params[0]
		    var postData={
		    		matchCode:this.matchCode,
		    		competition:1
		    }
		    axios.post('/marlin/sign/data/plan/query/list',postData)
		    .then(function(res){
		    		if(res.data.code==0){
		    			self.plan=res.data.rst
		    			self.plan1=res.data.rst
		    			self.plan2=res.data.rst
		    		}else{
		    			self.$message({
		    				message:res.data.msg,
		    				type:'warning'
		    			})
		    		}
		    })

//		    this.href="/marlin/sign/data/sign/individual/export?"+this.matchInfo.matchCode
        let nowDate=new Date().getTime()
        this.nowDate=nowDate
        this.matchInfoList()
		    this.onSubmit()
      console.log(this.nowDate,this.matchInfo.signEndTime)
		},
		methods:{
      matchInfoList(){
        let self=this
        axios.get('/marlin/sign/data/match/query/single/'+this.matchCode)
          .then(function (res) {
            console.log('resresres',res)
            self.matchInfo=res.data.rst[0]
          })
          .catch(function (res) {

          })
      },
			onSubmit() {
			  console.log(1)
	      	    var self=this
	       		this.formInline.clubCode=this.userInfos.clubCode
	       		this.formInline.matchCode=this.matchCode
	       		axios.post('/marlin/sign/data/sign/union/query/info/list',this.formInline)
	       		.then(function(res){
	       			if(res.data.code==0){
	       				self.tableData3=res.data.rst
						    self.person=res.data.count
                console.log(res)

//	       				self.$message({
//				          message: '查询成功',
//				          type: 'success'
//				        });
				        self.person=res.data.count
	       			}else{
	       				self.$message({
				          message: res.data.msg,
				          type: 'warning'
				        });
	       			}
	       		})
	       		.catch(function(res){
	       			overdue(res.response,res.response.status,self)
	       		})
	      	},
	    add(){
	      		//获取成员
	      		var self=this
	      		this.dialogFormVisible=true
	      		let planItemArray = []
	      		for(let i=0;i<this.plan.length;i++){
	      			let planSexArray = [];
	      			let planSexArrayName = [];
	      			//性别-男
	      			if(this.plan[i].planSexMen == 1){
	      				planSexArray.push(0);
	      				planSexArrayName.push('男子');
	      			}
	      			//性别-女
	      			if(this.plan[i].planSexWomen == 1){
	      				planSexArray.push(1);
	      				planSexArrayName.push('女子');
	      			}
	      			//性别-混合
	      			if(this.plan[i].planSexMix == 1){
	      				planSexArray.push(2);
	      				planSexArrayName.push('混合');
	      			}
	      			let planWeaponArray = [];
	      			let planWeaponNameArray = [];
	      			//剑种-花剑
	      			if(this.plan[i].planWeaponFoil == 1){
	      				planWeaponArray.push(1);
	      				planWeaponNameArray.push("花剑");
	      			}
	      			//剑种-重剑
	      			if(this.plan[i].planWeaponEpee == 1){
	      				planWeaponArray.push(2);
	      				planWeaponNameArray.push("重剑");
	      			}
	      			//剑种-佩剑
	      			if(this.plan[i].planWeaponSabre == 1){
	      				planWeaponArray.push(3);
	      				planWeaponNameArray.push("佩剑");
	      			}
	      			for(let j=0;j<planSexArray.length;j++){
	      				for(let k=0;k<planWeaponArray.length;k++){
	      					let planItem = {
	      									"planCode":this.plan[i].planCode,
	      									"planName":this.plan[i].planName,
	      									"planSex":planSexArray[j],
	      									"planWeapon":planWeaponArray[k],
	      									"planCompetition":"2",
	      									"itemName":this.plan[i].planName+planSexArrayName[j]+planWeaponNameArray[k]+"团体",
	      									"itemCode":this.plan[i].planCode+"-"+planSexArray[j]+"-"+planWeaponArray[k]+"-"+"2"
	      									}
	      					planItemArray.push(planItem);
	      				}
	      			}

	      		}
	      		this.planItemList = planItemArray;
	      	},
      selectToSex(val){
	      		var self=this
	      		if(val!=''){
	      			for(var i=0;i<self.plan.length;i++){
		      			if(self.plan[i].planCode==val){
		      				self.plan1=self.plan[i]
		      			}
		      		}
	      		}

	      	},
	      	//添加
      submitForm(formName) {
		      	var self=this
		      	this.ruleForm.clubCode=this.userInfos.clubCode
		      	this.ruleForm.matchCode=this.$route.query.matchCode

		      	let itemArray = this.ruleForm.planCode.split("-");
		      	//计划编码
//		      	console.log(this.ruleForm.planCode)
		      	this.ruleForm.planCode=itemArray[0];
		      	//性别
		      	this.ruleForm.planSex = itemArray[1];
		      	//剑种
		      	this.ruleForm.planWeapon = itemArray[2];
		      	//赛式
		      	this.ruleForm.planCompetition = itemArray[3];

		        this.$refs[formName].validate((valid) => {
		          if (valid) {
		            var postData=self.ruleForm
		            axios.post('/marlin/sign/data/sign/union/add/info',postData)
		            .then(function(res){
		            		if(res.data.code==0){

		            			self.dialogFormVisible=false
		            			self.$message({
		            				message:'添加成功',
		            				type:'success'
		            			})
//		            			console.log(res)
		            			self.ruleForm={}
		            			self.onSubmit()
		            		}else{
		            			self.$message({
					          message: res.data.msg,
					          type: 'warning'
					        });
		            		}
		            })
		            .catch(function(res){
		            		overdue(res.response,res.response.status,self)
		            })
		          } else {
		            return false;
		          }
		        });
	      	},
      editSubmit(formName){
	      		var self=this
	      		this.$refs[formName].validate((valid) => {
		          if (valid) {
		            var postData={
		            		"signCode":self.editForm.signCode,//报名编码 必填
						"clubCode":self.editForm.clubCode,//俱乐部编码 必填
						"matchCode":self.editForm.matchCode,//比赛编码 必填
						"planCode":self.editForm.planCode,//组名 必填
						"memberCode":self.editForm.memberCode,//成员编码 必填
						"teamName":self.editForm.teamName,
						"planSex":self.editForm.planSex,//性别 必填
						"planWeapon":self.editForm.planWeapon,//剑种 必填
						"planCompetition":2//个人，团体 必填
		            }
		            axios.post('/marlin/sign/data/sign/union/update/info',postData)
		            .then(function(res){
		            		self.editFormVisible=false
		            		self.$message({
		            			message:'修改成功！',
		            			type:'success'
		            		})
		            		self.onSubmit()
		            })
		            .catch(function(res){
		            		overdue(res.response,res.response.status,self)
		            })
		          } else {
		            return false;
		          }
		        });
	      	},
		    selectToSex2(val){
	      		var self=this
	      		if(val!=''){
	      			for(var i=0;i<self.plan.length;i++){
		      			if(self.plan[i].planCode==val){
		      				self.plan2=self.plan[i]
		      			}
		      		}
	      		}

	      	},
       selectable(row,index){
		   		return row.payStatus==0
		   },
		    handleEdit(index,row){
		    		this.editFormVisible=true
				this.editForm.newTeamName=row.teamName
		    		this.editForm=row
		    },
		    	lookInfo(index,row){
		    		var self=this
	      		this.lookVisible=true
//	      		console.log(row)
	      		var postData={
	      			"clubCode":row.clubCode,//俱乐部编码 必填
					"matchCode":row.matchCode,//比赛编码 必填
					"signCode":row.signCode,//报名编码 必填
					"planCode":row.planCode,//策划编码 必填
					"planSex":row.planSex,//性别 必填
					"planWeapon":row.planWeapon//剑种 必填
	      		}
	      		axios.post('/marlin/sign/data/sign/union/query/orther/list',postData)
	      		.then(function(res){
	      			if(res.data.code==0){
	      				self.lookData=res.data.rst
//	      				console.log(res)
	      			}else{
//	      				console.log(res)
	      			}
	      		})
	      		.catch(function(err){
	      			overdue(res.response,res.response.status,self)
	      		})
	      	},
		    handleDelete(index,row){
		    		var self=this
//		    		console.log(row)
		    		this.$confirm('此操作会删除此条记录, 是否继续?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		      }).then(() => {
					axios.get('/marlin/sign/data/sign/union/delete/info/'+row.signCode)
					.then(function(res){
						if(res.data.code==0){
							self.$message({
								message:'您已删除成功！',
								type:'success'
							})
							self.onSubmit()
						}else{
							self.$message({
								message:res.data.msg,
								type:'warning'
							})
						}
					})
					.catch(function(res){

					})
		        }).catch(() => {
		          this.$message({
		            type: 'info',
		            message: '已取消删除'
		          });
		        });
		   },
		   teamMemberlist(index,row){
//		   	console.log(row)
		   },
		   //查看列表
		   handleLook(index,row){
				this.personShow=true
		   		this.personList=row.memberList
		   		this.delStatus=row.payStatus
		   		this.rowOption=row
		   		this.sCode=row.signCode
		   },
		   //查询可以新增加的成员
		   addPerson(row){
		   	    var self=this
				this.personShow=false
				this.addPersonShow=true
				this.addPersonForm.signCode = row.signCode;
				this.plan.planSexMen=0
			    axios.post('/marlin/sign/data/club/member/query/list',{
					"memberName":"",//姓名 模糊匹配 选填
					"memberSex":null,//性别 0-男 1-女  全部的时候，不传此参数
					"memberLevel":null,//运动员等级 0-大众 1-专业 全部的时候，不传此参数
					"memberWeapon":null,//剑种 1-花剑 2-重剑 3-配剑全部的时候，不传此参数
					"bithStartDate":"",//出生日期开始
					"bithEndDate":""//出身日期结束
					})
			    .then(function(res){
			    		let newOption=[]
			    		if(res.data.code==0){
						self.options=res.data.rst
						let index=0
						for(var i=0;i<self.options.length;i++){
							let flag=true
							for(var j=0;j<row.memberList.length;j++){
								if(row.memberList[j].memberCode==self.options[i].memberCode){
									flag=false
									break;
								}
							}
							if(flag && row.planSex !=2 &&
									row.planSex!=self.options[i].memberSex){
									flag=false;
								}
//								console.log(row.planWeapon,self.options[i].memberWeapon)
						    if(flag && row.planWeapon!=self.options[i].memberWeapon){
									flag=false;
								}
						    	if(flag && (self.options[i].memberBith<row.planBirthStartTime ||
										    self.options[i].memberBith>row.planBirthEndTime)){
									flag=false;
								}
							if(flag){
                let memberFlag = self.checkMemberContact(self.options[i])
                self.options[i].disabled = !memberFlag
								newOption.push(self.options[i])
							}
						}
						self.newOption=newOption
			    		}
			    })
			    .catch(function(res){
			    		overdue(res.response,res.response.status,self)
			    })
		   },

		   //增加成员提交按钮
		   addPersonSubmimt(){
		   	    var self=this
//		   		console.log(this.addPersonForm.memberCode)
		   		var postData={
		   			signCode:this.addPersonForm.signCode,
		   			memberCode:this.addPersonForm.memberCode
		   		}
		   		axios.post('/marlin/sign/data/sign/union/add/member',postData)
		   		.then(function(res){
		   			if(res.data.code==0){
		   				self.addPersonShow=false
		   				self.$message({
		   					message:'添加成功',
		   					type:'success'
		   				})
		   				self.addPersonForm = {};
		   				self.onSubmit()
		   			}
		   			else{
		   				self.$message({
		   					message:res.data.msg,
		   					type:'warning'
		   				})
		   			}
		   		})
		   		.catch(function(res){
		   			overdue(res.response,res.response.status,self)
		   		})
		   },
		   //成员删除
		   personDelete(index,row){
//		   		console.log(this.sCode)
//		   		console.log(row)
		   		var self=this
		   		var postData={
		   			signCode:row.signCode,
		   			memberCode:row.memberCode
		   		}
		    		this.$confirm('此操作会删除此条记录, 是否继续?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		      }).then(() => {
					axios.post('/marlin/sign/data/sign/union/delete/member',postData)
					.then(function(res){
						if(res.data.code==0){
							self.$message({
								message:'您已删除成功！',
								type:'success'
							})
							self.personShow=false
							self.onSubmit()
						}else{
							self.$message({
								message:res.data.msg,
								type:'warning'
							})
						}
					})
					.catth(function(res){

					})
		        }).catch(() => {
		          this.$message({
		            type: 'info',
		            message: '已取消删除'
		          });
		        });
		   },
		   handleSelectionChange(val) {
		        this.multipleSelection = val;
				var signCodeList=[]
//				console.log(val)
				for(var i=0;i<this.multipleSelection.length;i++){
					signCodeList.push(this.multipleSelection[i].signCode)
				}
				this.signCodeList=signCodeList
//				console.log(this.signCodeList)
		   },
		   onlinePayment(){

         if(this.nowDate<(this.matchInfo.signEndTime+24*60*60*1000)){
           var self=this
           var postData={
             "matchCode": this.$route.query.matchCode,//比赛编码 必填
             "payType":3,//支付类型 1-比赛个人报名 2-比赛团队报名 3-比赛联合报名
             "payWay":1,//支付方式 1-支付宝 2-微信
             "signCodeList":this.signCodeList
           }

           if(this.signCodeList.length>0){

//					console.log(self.multipleSelection)
//              console.log(1)
             var flag = true;
             for(var i=0;i<self.multipleSelection.length;i++){
               if(flag){
                 if(self.multipleSelection[i].memberList.length<1 || self.multipleSelection[i].memberList.length >2){
                   flag = false;
                   self.$message({
                     message:'选中项中存在团队成员不是1个或2个！',
                     type:'warning'
                   })
                   break;
                 }
               }
             }
             if(flag){
               var url='/pay/pay.html?matchCode='+this.$route.query.matchCode+"&payType="+3+"&payWay="+1+"&signCodeList="+this.signCodeList.toString()
               window.open(url,'_black')
             }
           }else{
             self.$message({
               message:'请至少选择一个团队！',
               type:'warning'
             })
           }
         }

		   },
      checkMemberContact(row){
        let flag = true
        if(undefined == row || null == row){
          flag = false
        }
        if(flag && (null == row.memberContactName || row.memberContactName.length < 1)){
          flag = false
        }
        if(flag && (null == row.memberContactTel || row.memberContactTel.length < 1)){
          flag = false
        }
        if(flag && (null == row.memberContactIdcard || row.memberContactIdcard.length < 1)){
          flag = false
        }
        if(flag && (null == row.memberContactEmail || row.memberContactEmail.length < 1)){
          flag = false
        }
        if(flag && (null == row.memberContactAddress || row.memberContactAddress.length < 1)){
          flag = false
        }
        return flag
      },
		   cellMouseEnter(row,column,cell,event){
		   		row.id=0
//		   		console.log(row)
		   	},
		   cellMouseLeave(row,column,cell,event){
		   		row.id=1
		   }
		}
	}
</script>

<style scoped>
	.elTable{
		margin-top: 20px;
	}
	.cell p a{
		color: #3A8EE6;
		cursor: pointer;
	}
	.el-form-item{
		margin-bottom: 0;
	}
  .sign-remark{
    color: #DD6161;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/UnionGroup.vue